import LmParticipants from '@/components/form/elements/LmParticipants'

export default {
  components: {
    LmParticipants
  },
  data () {
    return {
      workflowComponentsOptions: {
        disabledOption: 'Seleccione una opción',
        content: [
          { value: 'workflowFixedSection', text: this.$t('workflow_fixed_section_title') },
          { value: 'workflowDynamicSection', text: this.$t('workflow_dynamic_section_title') }
        ]
      }
    }
  },
  props: {
  },
  computed: {
    enableDocumentWorkflowFeature () {
      return process.env?.VUE_APP_ENABLE_DOCUMENT_WORKFLOW === 'yes'
    },
    documentHasWorkflowSections () {
      return this.workflowSections?.length > 0
    }
  },
  methods: {
    addWorkflowSection () {
      this.formData.workflowSections.push({
        id: this.generateId(),
        type: 'workflowFixedSection',
        title: this.$t('workflow_fixed_section_title'),
        participants: []
      })
    },
    removeWorkflowSection (elementIndex) {
      this.formData.workflowSections.splice(elementIndex, 1)
    },
    changeWorkflowSectionType (type, elementIndex) {
      this.formData.workflowSections[elementIndex].type = type
      this.formData.workflowSections[elementIndex].title = this.workflowComponentsOptions.content.find(i => i.value === type).text
    },
    workflowSectionTitle (element) {
      if (this.workflowSectionIsDynamic(element)) {
        return this.$t('workflow_dynamic_section_title')
      } else if (this.workflowSectionIsFixed(element)) {
        return this.$t('workflow_fixed_section_title')
      }
    },
    workflowSectionIsFixed (element) {
      return element?.type === 'workflowFixedSection'
    },
    workflowSectionIsDynamic (element) {
      return element?.type === 'workflowDynamicSection'
    }
  }
}
